import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
`;

const Icon = styled.div`
  display: inline-flex;
  position: relative;
  .invoice-more-icon {
    cursor: pointer;
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
    :hover {
      background-color: var(--background-muted);
      border-radius: var(--border-radius-4);
    }
  }
  .invoice-icon {
    fill: var(--brand-primary);
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 14px 0 24px;
  ${mobile_xl(css`
    align-items: center;
    padding: 9px 20px 9px 12px;
    margin: 0 -20px;
    position: sticky;
    z-index: 999;
    top: 0;
    background: var(--background-secondary);
  `)}
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
`;

const ViewDiv = styled.div`
  width: 100%;
  padding-top: 20px;
`;

export { HeaderLeft, Icon, Content, Heading, Title, ViewDiv };
